import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, OnChanges, Injector} from '@angular/core';
import {fadeInAnimation, fadeInOut} from '../../service/routerTransition';
import {TranslateService} from '@ngx-translate/core';
import { ModalBase } from '../modal.base.component';
import { DialogService } from '../../service/dialog.service';
import { UserService } from '../../service/user.service';
import { Constant } from '../../constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppQueries } from 'src/app/state';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
import { OptionFee } from '../detail-fee/detail-fee';
import { UserProfile } from 'src/app/common/models/users.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/common/service/product.service';
import { DateUtil } from 'src/app/common/utils/date.util';
import { CustomComponentService } from 'src/app/main/services/custom-component.service';
@Component({
    selector: 'detail-new-fund',
    templateUrl: './detail-new-fund.html',
    animations: [fadeInAnimation, fadeInOut],
    host: {'[@fadeInAnimation]': ''}
  })
  
export class DetailNewFund extends ModalBase implements OnInit, OnChanges, OnDestroy {
    @Input('product') product;
    isIssuer: boolean = false;
    isAgent: boolean = false;
    Constant = Constant;
    noteBuyFeeDiscount: any;
    buyFeesDiscount: any[] = [];
    noteSellFeeDiscount: any;
    sellFeesDiscount: any[] = [];
    optionBuyFee: OptionFee = new OptionFee({
        valueTitle: 'Giá trị mua',
        valueUnit: '',
        feeTitle: 'Phí mua',
        feeUnit: '%',
    });
    optionSellFee: OptionFee = new OptionFee({
        valueTitle: 'Thời gian nắm giữ',
        valueUnit: 'tháng',
        feeTitle: 'Phí bán',
        feeUnit: '%',
    });
    user: UserProfile = new UserProfile();
    subscriptions?: Subscription[] = [];
    approveDays: string = ' hàng tuần';
    constructor(
        private translate: TranslateService,
        private eventManager: EventManagerService,
        private appQueries: AppQueries,
        public router: Router,
        public activeModal: NgbActiveModal,
        private userService: UserService,
        public productService: ProductService,
        public customComponentService: CustomComponentService,
        dialog: DialogService,
        injector: Injector) {
            super(injector)
    }
    ngOnInit() {
        this.product = this.product || {};
        this.subscriptions = [
            this.appQueries.userProfile$
            .subscribe((userProfile) => {
                this.user = userProfile;
                if (this.user.userType === Constant.ISSUER) {
                this.isIssuer = true;
                } else if (this.user.userType === Constant.FUND_AGENT || this.user.userType === Constant.BOND_AGENT || 
                    this.user.userType === Constant.CD_AGENT) {
                    this.isAgent = true;
                }
            })
        ];
        this.userService.subProfile()
        .then((res: any) => {
            if (res.userType === Constant.ISSUER) {
                this.isIssuer = true;
            } else if (res.userType === Constant.FUND_AGENT || res.userType === Constant.BOND_AGENT || res.userType === Constant.CD_AGENT) {
                this.isAgent = true;
            }
        });
        this.executeFee();
    }
    ngOnDestroy()  {
        this.eventManager.destroys(this.subscriptions);
    }
    ngOnChanges() {
        this.product = this.product || {};
        if (this.product.code === 'TBLF') {
            this.approveDays = ': tuần thứ nhất và tuần thứ ba hàng tháng';
        }
        this.executeFee();
    }
    executeFee() {
        if (this.product.productTradingSession) {
            let closeBankNote = this.product.productTradingSession.closedBankNoteTimeString;
            closeBankNote = 'Trước ' + closeBankNote.substring(0, 5) + ' ngày ' + closeBankNote.substring(6, closeBankNote.length);
            this.product.productTradingSession.closedBankNoteString = closeBankNote;
            let closedOrderBookTimeString = this.product.productTradingSession.closedOrderBookTimeString;
            closedOrderBookTimeString = 'Trước ' + closedOrderBookTimeString.substring(0, 5) + ' ngày ' + closedOrderBookTimeString.substring(6, closedOrderBookTimeString.length);
            this.product.productTradingSession.closedOrderBookString = closedOrderBookTimeString;
        }
        this.product.feeBuys.forEach((item) => {
            if (item.beginRelationalOperator) {
                switch (item.beginRelationalOperator.name) {
                    case '>': 
                    item.beginRelationalOperator.reverse = '<';
                    break;
                    case '>=': 
                    item.beginRelationalOperator.reverse = '<=';
                    break;
                }
            }
            if (item.endRelationalOperator) {
                switch (item.endRelationalOperator.name) {
                    case '>': 
                    item.endRelationalOperator.reverse = '<';
                    break;
                    case '<': 
                    item.endRelationalOperator.reverse = '>';
                    break;
                    case '>=': 
                    item.endRelationalOperator.reverse = '<=';
                    break;
                    case '<=': 
                    item.endRelationalOperator.reverse = '>=';
                    break;
                }
            }
            
        })
        this.product.productFeeDiscountList = this.product.productFeeDiscountList || [];
        this.buyFeesDiscount = this.product.productFeeDiscountList.filter(item => item.type === 'BUY');
        this.noteBuyFeeDiscount = this.buyFeesDiscount[0] ? this.buyFeesDiscount[0].note : '';
        this.sellFeesDiscount = this.product.productFeeDiscountList.filter(item => item.type === 'SELL');
        this.noteSellFeeDiscount = this.sellFeesDiscount[0] ? this.sellFeesDiscount[0].note : '';
    }
    buy() {
        if (this.user && this.user.id) {
            this.router.navigate(['/account/investor/market/dashboard']);
            setTimeout(() => {
                this.eventManager.broadcast({ 
                    name: 'choose-fund-buy', 
                    content: {
                        product: this.product
                    }  
                });
            }, 500)
        } else {
            this.router.navigate([Constant.url_login]);
        }
        this.dismiss();
    }
}
